import config from '@/temp/config';
import type { AppContext } from '@/types';
import { getBaseUrl } from '@/utils/api';
import { RestLayoutService } from '@sitecore-jss/sitecore-jss-vue';

const createService = (appContext: AppContext) =>
    new RestLayoutService({
        apiHost: getBaseUrl(appContext),
        apiKey: config.sitecoreApiKey,
        siteName: appContext.sitecoreSiteName,
        configurationName: 'jss'
    });

export const fetchLayoutData = async (appContext: AppContext, itemPath: string) => {
    try {
        const service = createService(appContext);
        const data = await service.fetchLayoutData(itemPath);

        if (data?.sitecore?.route && data?.sitecore?.context) {
            return data;
        } else {
            throw Error('Received invalid data from layout service');
        }
    } catch (error) {
        console.error('Failed to fetch layout data', error);
        return null;
    }
};
